import { render, staticRenderFns } from "./Dian.vue?vue&type=template&id=122e35ab&scoped=true&"
import script from "./Dian.vue?vue&type=script&lang=js&"
export * from "./Dian.vue?vue&type=script&lang=js&"
import style0 from "./Dian.vue?vue&type=style&index=0&id=122e35ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e35ab",
  null
  
)

export default component.exports